import { PollController } from './poll/poll';

angular.module('capability-ng-poll').controller('PollController', PollController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/views/poll_view_module.ts